import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import Icon from 'builder/components/Icon'
import { ModalClose } from '../ModalClose'

export const Modal = styled.div`
  display: flex;
  position: relative;

  ${Media.Tablet`
    flex-direction: column;
    width: 544px;
  `}
`

export const RightModalContainer = styled.div`
  border-radius: 0 ${Spacing.S} ${Spacing.S} 0;
  width: 496px;

  ${Media.Tablet`
    order: 0;
    border-radius: unset;
    width: unset;
    border-radius: unset;
 `}
`

export const Image = styled.img`
  height: 100%;
  width: 100%;

  ${Media.Tablet`
    border-radius: ${Spacing.S} ${Spacing.S} 0 0;
 `}

  ${Media.Phone`
    height: 206px;
  `}
`

export const Container = styled.div`
  padding: 40px 40px 36px;
  display: flex;
  flex-direction: column;
  background-color: ${Colors.White};
  border-radius: ${Spacing.S} 0 0 ${Spacing.S};
  width: 496px;
  position: relative;

  ${Media.Tablet`
    border-radius: unset;
    order: 1;
    padding: ${Spacing.L};
    width: unset;
    border-radius: 0 0 ${Spacing.S} ${Spacing.S};
 `}
`

export const Subtitle = styled.span`
  ${Typography.Caps};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral80};
  margin-top: ${Spacing.L};
`

export const Title = styled.span`
  ${Typography.M};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};

  ${Media.Phone`
    text-align: center;
  `}
`

export const Description = styled.span`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
  margin-top: 24px;

  ${Media.Phone`
    margin-top: ${Spacing['2XS']};
  `}
`

export const Items = styled.div`
  padding: ${Spacing.XS};
  gap: ${Spacing['2XS']};
  background-color: ${Colors.Neutral5};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin-top: ${Spacing['2XS']};
`

export const ItemContainer = styled.div`
  gap: 4px;
  display: flex;
`

export const Tick = styled(Icon.TickLarge)`
  color: ${Colors.Green40};
`

export const Item = styled.span`
  ${Typography.Caption};
  color: ${Colors.Neutral80};
`

export const CloseButton = styled(ModalClose)`
  position: absolute;
  top: 32px;
  right: 32px;

  ${Media.Phone`
    top: 20px;
    right: 20px;
  `}
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${Spacing['2XS']};
  margin-top: ${Spacing.S};
`

export const MobileContent = styled.div`
  padding: 20px 20px 32px;
  display: flex;
  flex-direction: column;
`
